import React, {useEffect, useRef, useState} from 'react';

import CardHeader from '../../components/common/card-header/CardHeader';
import {
  Card,
  FlexItem,
  FlexLayout, Link,
  StackLayout, Text, H2
} from '@salt-ds/core';
import Constants from '../../components/common/Constants';
import '../CommonCard.css';
import CardAlert from '../../components/common/card-alert/CardAlert';
import {useNavigate} from 'react-router';
import {useLocation} from 'react-router';
import PageNavigation from '../../components/common/page-navigation/PageNavigation';

function ForgotUserOrOrgIdComplete(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const {formData} = location.state || {formData: {email: ""}};

  const [hasError, setHasError] = useState(true);
  const [errorMessage, setErrorMessage] = useState(Constants.forgotUserOrOrgIdCompleteStepSuccessMessage(sessionStorage.getItem("userEmail")));
  const [isLoading, setIsLoading] = useState(false);
  const mainRef = useRef(null);
  const [headerContent, setHeaderContent] = useState(<CardAlert status={"success"}
    setHasError={setHasError}>{errorMessage}</CardAlert>);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);

    //Submit the form
    navigate('/');

  }
  useEffect(() => {
    if (location.state?.from !== '/forgotUserOrOrgIdCard' && location.state?.from !== '/forgotUserOrOrgIdEmail') {
      navigate('/');
    }
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [navigate,location]);

  return (
    <main ref={mainRef} role="main" aria-label="Forgot User or Org ID Complete" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
          <div>
            {
              headerContent
            }
          </div>
        </FlexItem>
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <form autoComplete="off" data-testid="form" onSubmit={handleSubmit}>
                <fieldset disabled={isLoading} style={{border:0, padding:0, margin:0}}>
                <StackLayout gap={4}>
                  <CardHeader heading={Constants.forgotUserOrOrgIdTitle}
                    subheading={Constants.forgotUserOrOrgIdCompleteStep}
                    style={{width: "58%"}} />
                  <FlexItem>
                    <Text>
                      {Constants.forgotUserOrOrgIdCompleteStepInstructionHeader1}
                    </Text>
                  </FlexItem>
                  <FlexItem>
                    <Text>
                      {Constants.forgotUserOrOrgIdCompleteStepInstructionHeader2(sessionStorage.getItem("userEmail"))}
                    </Text>
                  </FlexItem>
                  <FlexItem>
                    <H2>
                      Forgot Your Password?
                    </H2>
                  </FlexItem>
                  <FlexItem>
                    <Link tabIndex={0} data-testid="link" color="info" onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        navigate(Constants.forgotPassword, {state: { from: Constants.forgotUserOrOrgIdComplete}});
                      }
                    }} onClick={() => navigate(Constants.forgotPassword, {state: { from: Constants.forgotUserOrOrgIdComplete}})}>
                      {Constants.forgotPasswordTitle}
                    </Link>
                  </FlexItem>
                </StackLayout>
                <PageNavigation isContinue={true} buttonText="CONTINUE TO LOG IN"/>
                </fieldset>
              </form>
            </FlexItem>
          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );
}

export default ForgotUserOrOrgIdComplete;